const translations = {
  stepOf: "Step {current} of {total}",
  finish: "Finish tour",
  skip: "Skip",
  resumeLater: "Resume later",
  guidedTours: "Guided Tours",
  startTour: "Start tour",
  gettingStartedTitle: "Getting Started",
  welcomeTitle: "Welcome to AVS ERP",
  welcomeBody:
    "This sidebar is your main navigation — every module for orders, gold, manufacturing, and billing lives here.",
  dashboardTitle: "Your Dashboard",
  dashboardBody:
    "The home screen shows today's priorities — pending orders, gold alerts, and quick actions.",
  peopleTitle: "Parties & KYC",
  peopleBody:
    "Create customers, karigars, and suppliers under People. Every workflow links to a Party record.",
  ordersTitle: "Customer Orders",
  ordersBody: "Track design requirements, delivery dates, and manufacturing status from Orders.",
  manufacturingTitle: "Manufacturing Books",
  manufacturingBody:
    "Job cards, process transfers, and bench custody are managed in Manufacturing Books.",
  goldBookTitle: "Worker Gold Book",
  goldBookBody:
    "Every gram issued to a karigar must be returned or accounted for in the Gold Book.",
  stockTitle: "Ready Stock",
  stockBody:
    "Finished jewellery enters Ready Stock with photos, barcodes, HUID, and location tracking.",
  billingTitle: "Billing & Invoices",
  billingBody: "Generate invoices, delivery challans, and gold settlements from Billing.",
  reportsTitle: "Reports",
  reportsBody: "Daily close, gold reconciliation, and manufacturing reports live under Reports.",
  customizationTitle: "Customization",
  customizationBody:
    "Terminology, dropdowns, books, formulas, and workflows are configured here — not in Settings.",
  settingsTitle: "Settings",
  settingsBody:
    "Account, users, security, and connection status — technical provider setup stays simple.",
  helpTitle: "Training Centre",
  helpBody: "Reopen guided tours, SOP lessons, and the help agent anytime from Help & Guide.",
  goldControlTitle: "Gold Control",
  goldBookStepTitle: "Worker Gold Book",
  goldBookStepBody: "Issue and receive gold with full custody tracking per karigar.",
  ledgerStepTitle: "Gold Stock Ledger",
  ledgerStepBody: "Vault balances and fine gold movements reconcile here.",
  platformAdminTitle: "Platform Administration",
  platformConsoleTitle: "Platform Owner Console",
  platformConsoleBody:
    "AVS internal control plane for tenants, billing, communications, and security.",
};

export default translations;
